import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Form, Button, Message, Radio, Input } from 'semantic-ui-react'
import Validator from 'validator'
import { withRouter } from "globals/utils"
import InputAuthCode from 'components/inputs/authcode'
import InputPassword from 'components/inputs/password'
import InlineError from 'components/inlineerror'
import { lostDevice } from 'data/auth/action'
import {MAIN_COLOR} from 'globals/consts'

class LoginForm extends React.Component {
  state = {
    data: {
      email: '',
      password: '',
      twoFactor: '',
      rememberBrowser: false,
    },
    step: 'login',
    loading: false,
    sent: false,
    errors: {}
  }

  onChange = (e, h) =>{
    if (e.target.name === 'rememberBrowser') {      
      this.setState({ data: { ...this.state.data, [e.target.name]: h.checked}})
    } else {
      this.setState({ data: { ...this.state.data, [e.target.name]: e.target.value}})
    }
  }

  onAuthCode = (e) =>{      
    const { data } = this.state
    data.twoFactor = e
    this.setState({ data })
  }
  
  onSubmit = () => {
    const errors = this.validate(this.state.data)
    this.setState({ errors })

    if(Object.keys(errors).length === 0){
      this.setState({loading:true})
      this.props
        .submit(this.state.data)
        .catch(err => {
          if (err && err.response && err.response.data) {
            if (err.response.data.error === "invalid_grant" || err.response.data.error === 'account_locked') {
              this.setState({step: 'login', errors: {global: err.response.data.error_description}, loading: false })
            } else if (err.response.data.error === "two_factor") {
              this.setState({step: 'otp', codeDesc: err.response.data.error_description, loading: false })
            } else if (err.response.data.error === "invalid_phone") {
              this.setState({step: 'login', errors: {global: err.response.data.error_description}, loading: false })
           /*  } else if ( err.response.data.error ==='confirm_email') {
              this.props.navigate('/confirmation?email='+this.state.data.email) */
            } else if (err.response.data.error === "confirm_phone" || err.response.data.error === "confirm_email") {
             /*  sessionStorage.setItem('email', this.state.data.email)
              sessionStorage.setItem('phone', err.response.data.error_description)
              this.props.navigate('/resendconfirm') */
              this.setState({ errors: {global: 'Account Error Contact Support accounts@retirementnavigator.ca'}, loading: false })
            } else if (err.response.data.error === "invalid_2fa") {
              this.setState({step: 'otp', errors: { global: err.response.data.error_description}, loading: false })
            } else {
              this.setState({ errors: {global: err.response.data.error_description}, loading: false })
            }
          } else {
            this.setState({ errors: { global: 'error occuired' }, loading: false })
          }  
        })
    }
  }

  onLostDevice = () =>{
    this.setState({step: 'lost'})
  }
  
  onSendLostDevice = () => {
    this.setState({sent: true})
    this.props.lostDevice(this.state.data).then(() => this.setState({loading: false, sent: false, step:'sent'}))
  }

  onReset = () => {
    this.setState({
      data: {
        email: '',
        password: '',
        twoFactor: '',
        rememberBrowser: false
      },
      step: 'login',
      loading: false,
      sent: false,
      errors: {}
    })
  }
  validate = (data) => {
    const errors = {}
    if(!Validator.isEmail(data.email)) errors.email = "Invalid Email"
    if(!data.password) errors.password = "Can't be blank"
    return errors
  }

  render(){
    const { data, errors, step, loading, sent, codeDesc } = this.state

    return (
      <Form loading={loading} style={{ minHeight: '210px', verticalAlign: 'bottom'}}>
        {errors.global && 
          <Message negative>
            {errors.global}
          </Message>
        }
        { step==='login' && 
          <React.Fragment>
            <Form.Field error={!!errors.email}>
              <Input tabIndex={1}
                type='email'
                id='email'
                icon='mail'
                iconPosition='left'
                name='email'
                placeholder='Email'
                value={data.email}
                onChange={this.onChange}
              />
              {errors.email && <InlineError text={errors.email} />}
            </Form.Field>
            <Form.Field error={!!errors.password}>
              <InputPassword tabIndex={2}
                id='password'
                name='password'
                placeholder='Password'
                value={data.password}
                onChange={this.onChange}
              />
              {errors.password && <InlineError text={errors.password} />}
            </Form.Field>
            <Link className='forgotPasswordLink' to='/forgotpassword' tabIndex={-1}>Forgot password?</Link>
            <div className='LoginForm-bottom'>
              <Button size={'big'} onClick={this.onSubmit} style={{color: 'white', background: MAIN_COLOR}} primary tabIndex={3}>Login</Button>              
              <p>or</p>
              <Link className='ui button big' to='/signup' tabIndex={4}>Sign up</Link>              
            </div>
          </React.Fragment>
        }
        { step==='otp' && 
          <React.Fragment>
            <Form.Field error={!!errors.twoFactor}>
              <label htmlFor="twoFactor">Enter {!codeDesc ? 'Authentication' : codeDesc} Code</label>
              <InputAuthCode tabIndex={1}
                name='twoFactor'
                id='twoFactor'
                type='number' 
                autoFocus
                length={6} 
                value={data.twoFactor}
                onChange={this.onAuthCode}
                onEnter={this.onSubmit}
              />
              <a href="#" onClick={this.onLostDevice} tabIndex={-1}>Don't have access to your Authenticator?</a> 
              {errors.twoFactor && <InlineError text={errors.twoFactor} />}
            </Form.Field>
            <Form.Field>
              <Radio toggle label="Remember this Browser"                   
                id='rememberBrowser'
                name='rememberBrowser'
                checked={data.rememberBrowser}
                onChange={this.onChange}
              />
            </Form.Field>
            <div className='LoginForm-bottom'>
              <Button size={'big'} onClick={this.onSubmit} style={{color: 'white', background: MAIN_COLOR}} primary tabIndex={3}>Login</Button>
              <p>or</p>
              <Button size={'big'} onClick={this.onReset} style={{color: 'white', background: MAIN_COLOR}} primary tabIndex={3}>Back To Login</Button>
            </div>
          </React.Fragment>
        }
        { step === 'lost' &&
          <React.Fragment>
            <p style={{paddingTop: '20px'}}>You have lost access to your Authentication Device.</p>
            <p>We will send an email to confirm this action, and will then switch your account to the email based authentication option so you can regain access to your account.</p>
            <div className='LoginForm-bottom'>
              <Button size={'big'} primary loading={sent} disabled={sent} onClick={this.onSendLostDevice}>Send Email</Button>
              <p>or</p>
              <Button size={'big'} onClick={this.onReset} style={{color: 'white', background: MAIN_COLOR}} primary tabIndex={3}>Back To Login</Button>
            </div>
          </React.Fragment>  
        }
        { step === 'sent' && 
          <React.Fragment>
            <p style={{paddingTop: '20px'}}>We have send an email with instructions on how to reset your authentication mode.</p>
            <div className='LoginForm-bottom'>              
              <Button size={'big'} primary onClick={this.onReset}>Back To Login</Button>
            </div>
          </React.Fragment>
        }
      </Form>
    )
  }
}

LoginForm.propTypes = {
  submit: PropTypes.func.isRequired
}

export default withRouter(connect(null, { lostDevice })(LoginForm))
